/**
 * HDR environment map presets shipped via @pmndrs/assets.
 * Each preset is a lazy import so only the selected HDR is bundled/loaded.
 */

export interface EnvPreset {
  label: string;
  load: () => Promise<string>;
}

export const ENV_MAP_PRESETS: Record<string, EnvPreset> = {
  studio: {
    label: "Studio",
    load: () => import("@pmndrs/assets/hdri/studio.exr").then((m) => m.default),
  },
  city: {
    label: "City",
    load: () => import("@pmndrs/assets/hdri/city.exr").then((m) => m.default),
  },
  dawn: {
    label: "Dawn",
    load: () => import("@pmndrs/assets/hdri/dawn.exr").then((m) => m.default),
  },
  sunset: {
    label: "Sunset",
    load: () => import("@pmndrs/assets/hdri/sunset.exr").then((m) => m.default),
  },
  forest: {
    label: "Forest",
    load: () => import("@pmndrs/assets/hdri/forest.exr").then((m) => m.default),
  },
  warehouse: {
    label: "Warehouse",
    load: () =>
      import("@pmndrs/assets/hdri/warehouse.exr").then((m) => m.default),
  },
  apartment: {
    label: "Apartment",
    load: () =>
      import("@pmndrs/assets/hdri/apartment.exr").then((m) => m.default),
  },
  lobby: {
    label: "Lobby",
    load: () => import("@pmndrs/assets/hdri/lobby.exr").then((m) => m.default),
  },
  night: {
    label: "Night",
    load: () => import("@pmndrs/assets/hdri/night.exr").then((m) => m.default),
  },
  park: {
    label: "Park",
    load: () => import("@pmndrs/assets/hdri/park.exr").then((m) => m.default),
  },
};

export const ENV_MAP_PRESET_KEYS = Object.keys(ENV_MAP_PRESETS);
